import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import api from '../api.js';

export default function AddFriend() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [sent, setSent] = useState({});

  useEffect(() => {
    if (!q.trim()) {
      setResults([]);
      return;
    }
    const t = setTimeout(() => {
      api
        .searchProfiles(q.trim())
        .then((r) => setResults(r?.profiles || r || []))
        .catch(() => setResults([]));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const send = async (fid) => {
    try {
      await api.sendFriendRequest(user.uid, fid);
      setSent((s) => ({ ...s, [fid]: true }));
    } catch {}
  };

  return (
    <div className="screen">
      <div className="screen-header">
        <button className="back-btn" onClick={() => navigate(-1)}>←</button>
        <h1>Add Friend</h1>
        <div className="spacer" />
      </div>

      <input
        className="input"
        placeholder="Search by name"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        autoFocus
        style={{ marginBottom: '1.25rem' }}
      />

      <div className="stack-sm">
        {results.map((p) => (
          <div className="friend-row" key={p.id || p.userId}>
            <div className="avatar">{p.displayName?.[0]?.toUpperCase() || '?'}</div>
            <div className="grow">
              <div className="name">{p.displayName || 'Unknown'}</div>
              <div className="sub">{p.city || '—'}</div>
            </div>
            <button
              className="btn btn-primary"
              style={{ padding: '0.5rem 0.9rem', fontSize: '0.8rem' }}
              disabled={sent[p.userId || p.id]}
              onClick={() => send(p.userId || p.id)}
            >
              {sent[p.userId || p.id] ? 'Sent' : 'Add'}
            </button>
          </div>
        ))}
        {q && results.length === 0 && (
          <div className="empty-state">No results</div>
        )}
      </div>
    </div>
  );
}
